import { Component, Field } from '@contember/interface'

export const AuthorPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
